/* eslint-disable max-len */
const React = require('react');

const Default = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.9966 25.5C19.8984 25.5 25.4932 19.9034 25.4932 13C25.4932 6.09657 19.8984 0.5 12.9966 0.5C6.09478 0.5 0.5 6.09657 0.5 13C0.5 19.9034 6.09478 25.5 12.9966 25.5Z" fill="white" stroke="#BFBFBF" />
    <rect x="1.75" y="1.75" width="22.5" height="22.5" rx="11.25" fill="#009EE3" stroke="white" strokeWidth="1.5" />
  </svg>
);

module.exports = Default;
